export default () => {
  const body = document.querySelector("body");

  const blockScroll = () => {
    body.style.height = "100vh";
    body.style.overflow = "hidden";
  };

  const freeScroll = () => {
    body.style.height = "auto";
    body.style.overflow = "auto";
  };

  return { blockScroll, freeScroll };
};
